import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import { AbilityContext } from '../../components/Ability'
import NotFound from '../NotFound'
import AiMessageListPage from './Features/AiMessageList'

const AiPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/notify"
        element={
          ability.can('manage', 'Order', 'ai') ? (
            <AiMessageListPage />
          ) : (
            <NotFound />
          )
        }
      />
    </Routes>
  )
}

export default AiPage
